<label class="toggle-wrapper" [class.toggle-wrapper--disabled]="disabled" [style.gap]="gap ? gap : '8px'">
  <input
    type="checkbox"
    class="toggle-input"
    [checked]="checked"
    [disabled]="disabled"
    role="switch"
    [attr.aria-checked]="checked"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    (change)="onChange($event)"
  />

  <span class="toggle" aria-hidden="true">
    <span class="toggle-thumb"></span>
  </span>

  <span class="toggle-label">
    <ng-content></ng-content>
  </span>
</label>